module.exports = __webpack_public_path__ + "img/img14.1b2c8652.png";